import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TimerService } from '../timer/timerService.service';

@Injectable({ providedIn: 'root' })
export class GamePlayService {
    score = new BehaviorSubject(0);
    newPlayer = new BehaviorSubject(false);
    level = new BehaviorSubject(1);
    combo = 0;
    // bonus = false;
    bonus = new BehaviorSubject(false);
    lifes = new BehaviorSubject(3);
    // current_page = 'choose';
    // next_page = '';
    game = {
        name: null,
        kind: null
    }
    addLeaderBoard = false;

    constructor(private timerService: TimerService) { }

    resetGame() {
        this.timerService.resetTimer();
        this.level.next(1);
        this.combo = 0;
        this.lifes.next(3);
        this.score.next(0);
        this.newPlayer.next(false);
        this.bonus.next(false);
    }

    // loadSounds() {
    //     this.chooseGame.load();
    //     this.chooseGame.muted = true;
    //     this.chooseGame.autoplay = true;
    //     this.matchGame.load();
    //     // this.correctAnswer.load();
    //     this.popUp2.load();
    //     // this.wrongAnswer.load();
    // }
}